import apiServices from './apiServices';
import { getmemberjobHistReq }  from './dtos';



class jobServices  {
    

     baseSvc = new apiServices();
     client = this.baseSvc.client;

   
    constructor() {
     
      }

      

      getJobHistory_older()
      {
        const request = new getmemberjobHistReq();
        request.skip = 10;
        request.take = 300;

        return this.client.get(request);
      }

    getJobHistory()
    {
        
        
        const request = new getmemberjobHistReq();
        request.skip = 0;
        request.take = 10;

        return this.client.get(request);


    }

    

}




export default jobServices;
